import { TREK_CATALOG } from './journeys/trekCatalog';

function slugWords(slug) {
	return slug.replace(/-/g, ' ');
}

function trekKeywords(trek) {
	return [
		trek.slug,
		slugWords(trek.slug),
		trek.region?.toLowerCase(),
		trek.district?.toLowerCase(),
		trek.trailhead?.toLowerCase(),
		trek.difficulty?.toLowerCase(),
		trek.highlight?.toLowerCase(),
		'trek',
		'trekking',
		'hike',
	].filter(Boolean);
}

const CORE_ITEMS = [
	{ label: 'Everest Base Camp', route: '/journeys/everest-base-camp', category: 'Journey', keywords: ['everest', 'ebc', 'trek', 'khumbu', 'lukla', 'namche'] },
	{ label: 'Annapurna Base Camp journey', route: '/journeys/annapurna-base-camp', category: 'Journey', keywords: ['annapurna', 'abc', 'pokhara', 'trek', 'ghandruk'] },
	{ label: 'Langtang Valley journey', route: '/journeys/langtang-valley', category: 'Journey', keywords: ['langtang', 'kyanjin', 'tamang', 'trek', 'syabrubesi'] },
	{ label: 'All guided journeys', route: '/journeys', category: 'Trek', keywords: ['journey', 'guided', 'trek', 'blueprint', 'routes', 'trails'] },
	{ label: 'Trekking in Nepal', route: '/trekking', category: 'Trek', keywords: ['trek', 'trekking', 'hike', 'trail', 'teahouse', 'permit'] },
	{ label: 'All destinations', route: '/#places', category: 'Places', keywords: ['destination', 'place', 'where', 'visit', 'explore', 'all'] },
	{ label: 'Plan your trip', route: '/#plan', category: 'Plan', keywords: ['plan', 'itinerary', 'prepare', 'start', 'lifecycle'] },
	{ label: 'Visa & Immigration', route: '/visa', category: 'Plan', keywords: ['visa', 'immigration', 'passport', 'permit', 'voa'] },
	{ label: 'Airport Arrival', route: '/arrival', category: 'Plan', keywords: ['airport', 'tia', 'arrival', 'taxi', 'sim', 'kathmandu airport'] },
	{ label: 'Safety & Emergency', route: '/safety', category: 'Plan', keywords: ['safety', 'emergency', 'ams', 'insurance', 'altitude', 'rescue'] },
	{ label: 'Transportation', route: '/transportation', category: 'Plan', keywords: ['transport', 'bus', 'flight', 'lukla', 'jeep', 'taxi'] },
	{ label: 'When to visit', route: '/seasonal-discovery', category: 'Plan', keywords: ['season', 'weather', 'october', 'monsoon', 'best time', 'month'] },
	{ label: 'Temples & sacred sites', route: '/temples', category: 'Discover', keywords: ['temple', 'stupa', 'boudhanath', 'pashupatinath', 'monastery', 'sacred'] },
	{ label: 'Festivals hub', route: '/festivals', category: 'Festival', keywords: ['festival', 'festivals', 'dashain', 'tihar', 'holi', 'calendar'] },
	{ label: 'Provinces of Nepal', route: '/provinces', category: 'Places', keywords: ['province', 'region', 'district', 'map'] },
	{ label: 'Trekking permits', route: '/guides/tims-card-trekking-permits', category: 'Plan', keywords: ['tims', 'permit', 'trekking permit', 'acap', 'park entry'] },
	{ label: 'Annapurna Base Camp', route: '/destinations/annapurna-base-camp', category: 'Discover', keywords: ['annapurna', 'abc', 'pokhara'] },
	{ label: 'Phewa Lake / Pokhara', route: '/destinations/phewa-lake', category: 'Discover', keywords: ['pokhara', 'phewa', 'lake', 'lakeside'] },
	{ label: 'Chitwan National Park', route: '/destinations/chitwan-national-park', category: 'Discover', keywords: ['chitwan', 'rhino', 'safari', 'wildlife', 'jungle'] },
	{ label: 'Lumbini', route: '/destinations/lumbini', category: 'Discover', keywords: ['lumbini', 'buddha', 'pilgrimage', 'birthplace'] },
	{ label: 'Upper Mustang', route: '/destinations/upper-mustang', category: 'Village', keywords: ['mustang', 'lo manthang', 'remote', 'tibetan', 'desert'] },
	{ label: 'Bhaktapur', route: '/destinations/bhaktapur-durbar-square', category: 'Discover', keywords: ['bhaktapur', 'durbar', 'kathmandu valley', 'newari'] },
	{ label: 'Boudhanath', route: '/destinations/boudhanath-stupa', category: 'Discover', keywords: ['boudhanath', 'stupa', 'tibetan'] },
	{ label: 'Pashupatinath', route: '/destinations/pashupatinath-temple', category: 'Discover', keywords: ['pashupatinath', 'hindu', 'temple', 'cremation'] },
	{ label: 'Sagarmatha National Park', route: '/destinations/sagarmatha-national-park', category: 'Discover', keywords: ['sagarmatha', 'everest region', 'khumbu', 'park'] },
	{ label: 'Swayambhunath', route: '/destinations/swayambhunath', category: 'Discover', keywords: ['swayambhunath', 'monkey temple', 'kathmandu'] },
	{ label: 'Patan Durbar Square', route: '/destinations/patan-durbar-square', category: 'Discover', keywords: ['patan', 'lalitpur', 'durbar', 'newari'] },
	{ label: 'Kathmandu Durbar Square', route: '/destinations/kathmandu-durbar-square', category: 'Discover', keywords: ['kathmandu', 'durbar', 'kumari'] },
];

const FESTIVAL_ITEMS = [
	['Dashain', 'dashain', ['dashain', 'durga', 'tika', 'october', 'family']],
	['Tihar', 'tihar', ['tihar', 'diwali', 'lights', 'dog festival', 'laxmi']],
	['Holi', 'holi', ['holi', 'colors', 'spring', 'festival of colors', 'march']],
	['Buddha Jayanti', 'buddha-jayanti', ['buddha', 'lumbini', 'may', 'buddhist']],
	['Indra Jatra', 'indra-jatra', ['indra', 'kathmandu', 'chariot', 'kumari', 'september']],
	['Bisket Jatra', 'bisket-jatra', ['bisket', 'bhaktapur', 'chariot', 'new year', 'april']],
	['Teej', 'teej', ['teej', 'women', 'pashupatinath', 'shiva', 'august']],
	['Maghe Sankranti', 'maghe-sankranti', ['maghe', 'sankranti', 'winter', 'january']],
	['Tamu Lhosar', 'tamu-lhosar', ['losar', 'gurung', 'tamang', 'new year']],
	['Maha Shivaratri', 'maha-shivaratri', ['shivaratri', 'shiva', 'sadhu', 'pashupatinath']],
	['Gai Jatra', 'gai-jatra', ['gai jatra', 'cow', 'kathmandu valley', 'august']],
	['Janai Purnima', 'janai-purnima', ['janai', 'rakhi', 'gosainkunda', 'august']],
	['Chhath', 'chhath', ['chhath', 'terai', 'sun', 'janakpur', 'madhesh']],
	['Ropain Festival', 'ropain-festival', ['ropain', 'rice planting', 'monsoon', 'village', 'june']],
	['Mani Rimdu', 'mani-rimdu', ['mani rimdu', 'tengboche', 'sherpa', 'monastery', 'everest']],
	['Yartung', 'yartung', ['yartung', 'horse', 'manang', 'mustang', 'august']],
].map(([label, slug, keywords]) => ({
	label,
	route: `/festivals/${slug}`,
	category: 'Festival',
	keywords,
}));

const VILLAGE_ITEMS = [
	{ label: 'Namche Bazaar', route: '/journeys/everest-base-camp', category: 'Village', keywords: ['namche', 'khumbu', 'sherpa', 'everest', 'acclimatization', 'village'] },
	{ label: 'Lo Manthang', route: '/journeys/upper-mustang', category: 'Village', keywords: ['lo manthang', 'mustang', 'walled city', 'remote', 'tibetan', 'village'] },
	{ label: 'Kagbeni', route: '/journeys/jomsom-muktinath', category: 'Village', keywords: ['kagbeni', 'mustang', 'kali gandaki', 'village', 'medieval'] },
	{ label: 'Ghandruk', route: '/journeys/annapurna-base-camp', category: 'Village', keywords: ['ghandruk', 'gurung', 'annapurna', 'village', 'homestay'] },
	{ label: 'Kyanjin Gompa', route: '/journeys/langtang-valley', category: 'Village', keywords: ['kyanjin', 'langtang', 'gompa', 'tamang', 'village'] },
	{ label: 'Sikles Village', route: '/journeys/sikles-trek', category: 'Village', keywords: ['sikles', 'gurung', 'pokhara', 'homestay', 'village'] },
	{ label: 'Marpha Village', route: '/journeys/jomsom-muktinath', category: 'Village', keywords: ['marpha', 'apple', 'mustang', 'thakali', 'village'] },
	{ label: 'Helambu Villages', route: '/journeys/helambu', category: 'Village', keywords: ['helambu', 'tamang', 'village', 'kathmandu', 'homestay'] },
	{ label: 'Tsum Valley Villages', route: '/journeys/tsum-valley', category: 'Village', keywords: ['tsum', 'gorkha', 'buddhist', 'remote', 'village', 'monastery'] },
	{ label: 'Nar Phu Valley', route: '/journeys/nar-phu-valley', category: 'Village', keywords: ['nar phu', 'manang', 'tibetan', 'remote', 'restricted', 'village'] },
	{ label: 'Humla & Limi Valley', route: '/journeys/humla-limi-valley', category: 'Village', keywords: ['humla', 'limi', 'simikot', 'remote', 'far west', 'tibetan', 'village'] },
	{ label: 'Phoksundo Lake Villages', route: '/journeys/phoksundo-lake', category: 'Village', keywords: ['phoksundo', 'dolpo', 'ringmo', 'remote', 'village', 'bon'] },
	{ label: 'Rara Lake', route: '/journeys/rara-lake', category: 'Village', keywords: ['rara', 'mugu', 'jumla', 'remote', 'far west', 'lake', 'village'] },
	{ label: 'Taplejung Villages', route: '/journeys/kanchenjunga-base-camp', category: 'Village', keywords: ['taplejung', 'kanchenjunga', 'limbu', 'remote', 'east', 'village'] },
	{ label: 'Ilam Tea Villages', route: '/journeys', category: 'Village', keywords: ['ilam', 'tea', 'plantation', 'eastern', 'village', 'hill'] },
	{ label: 'Chepang Hill Villages', route: '/journeys/chepang-hill', category: 'Village', keywords: ['chepang', 'indigenous', 'homestay', 'chitwan', 'village'] },
	{ label: 'Ruby Valley Homestays', route: '/journeys/ruby-valley', category: 'Village', keywords: ['ruby valley', 'gatlang', 'homestay', 'ganesh', 'village'] },
	{ label: 'Bandipur Hill Town', route: '/journeys', category: 'Village', keywords: ['bandipur', 'newari', 'hill town', 'tanahun', 'village'] },
	{ label: 'Janakpur', route: '/journeys/janakpur-pilgrimage', category: 'Village', keywords: ['janakpur', 'mithila', 'terai', 'temple', 'village'] },
];

const TREK_ITEMS = TREK_CATALOG.map((trek) => ({
	label: trek.title,
	route: `/journeys/${trek.slug}`,
	category: trek.restricted ? 'Remote trek' : 'Trek',
	keywords: trekKeywords(trek),
}));

const seen = new Set();
function dedupe(items) {
	return items.filter((item) => {
		const key = `${item.route}::${item.label}`;
		if (seen.has(key)) return false;
		seen.add(key);
		return true;
	});
}

export const HOME_SEARCH_INDEX = dedupe([
	...CORE_ITEMS,
	...TREK_ITEMS,
	...FESTIVAL_ITEMS,
	...VILLAGE_ITEMS,
]);

export const HOME_SEARCH_SUGGESTIONS = [
	'Everest Base Camp',
	'Visa',
	'Pokhara',
	'Chitwan',
	'October weather',
	'Airport arrival',
];

export const HOME_SEARCH_CHIPS = [
	{ label: 'Everest Base Camp', route: '/journeys/everest-base-camp' },
	{ label: 'Visa', route: '/visa' },
	{ label: 'Pokhara', route: '/destinations/phewa-lake' },
	{ label: 'Chitwan', route: '/destinations/chitwan-national-park' },
	{ label: 'October weather', route: '/seasonal-discovery' },
	{ label: 'Airport arrival', route: '/arrival' },
];

function haystackFor(item) {
	return [
		item.label.toLowerCase(),
		item.category.toLowerCase(),
		...item.keywords.map((k) => String(k).toLowerCase()),
	].join(' ');
}

export function searchHomeIndex(query, limit = 12) {
	const q = query.trim().toLowerCase();
	if (!q) return [];

	const tokens = q.split(/\s+/).filter(Boolean);

	return HOME_SEARCH_INDEX
		.map((item) => {
			const label = item.label.toLowerCase();
			const haystack = haystackFor(item);
			let score = 0;

			if (label === q) score += 100;
			else if (label.startsWith(q)) score += 40;
			else if (label.includes(q)) score += 25;

			tokens.forEach((token) => {
				if (label.includes(token)) score += 8;
				if (haystack.includes(token)) score += 4;
				item.keywords.forEach((keyword) => {
					const k = String(keyword).toLowerCase();
					if (k === token) score += 12;
					else if (k.includes(token) || token.includes(k)) score += 6;
				});
			});

			return { item, score };
		})
		.filter(({ score }) => score > 0)
		.sort((a, b) => b.score - a.score || a.item.label.localeCompare(b.item.label))
		.slice(0, limit)
		.map(({ item }) => item);
}

export function findHomeSearchMatch(query) {
	const results = searchHomeIndex(query, 1);
	return results[0] || null;
}
